<template>
    <v-main>
        <iframe v-if="showmanage"
            class="pl-2 pt-2 pb-2"
            style="display:block; width:50vw; height:100vh; border: none;" 
            :src="$vtrainingurl + '/account/manage-fe-employees?hide_sidebar=1&guid=' + guid">
        </iframe>
    </v-main>
  
</template>

<script>

export default {
    props: ['guid', 'usertype'],
    data() {
        return {
            showmanage: false
        }
    },
    created: function () {
        console.log(this.guid);
    },
    mounted() {
        if (this.usertype == "Front-End Admin") {
            this.showmanage = true;
        }
    }
}
</script>

<style>

</style>